var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEraseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.65385 1.37437C7.39985 1.37437 7.15917 1.48795 6.9977 1.68401L1.34386 8.5494C1.08538 8.86327 1.08538 9.31623 1.34386 9.6301L6.9977 16.4955C7.15917 16.6916 7.39985 16.8051 7.65385 16.8051H18.1538C18.8249 16.8051 19.4572 16.5214 19.9151 16.035C20.3712 15.5503 20.6192 14.9034 20.6192 14.2388V3.94071C20.6192 3.27614 20.3712 2.6292 19.9151 2.14451C19.4572 1.65808 18.8249 1.37437 18.1538 1.37437H7.65385Z",
    fill: "#C4C4C4",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9633 6.81838C16.3147 6.46691 16.3147 5.89706 15.9633 5.54559C15.6118 5.19411 15.042 5.19411 14.6905 5.54559L12.7019 7.53419L10.7133 5.54559C10.3618 5.19411 9.79196 5.19411 9.44048 5.54559C9.08901 5.89706 9.08901 6.46691 9.44048 6.81838L11.4291 8.80698L9.44048 10.7956C9.08901 11.1471 9.08901 11.7169 9.44048 12.0684C9.79196 12.4199 10.3618 12.4199 10.7133 12.0684L12.7019 10.0798L14.6905 12.0684C15.042 12.4199 15.6118 12.4199 15.9633 12.0684C16.3147 11.7169 16.3147 11.1471 15.9633 10.7956L13.9747 8.80698L15.9633 6.81838Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraseIcon);
export default __webpack_public_path__ + "static/media/EraseIcon.a438e0d0122f4dd6ad60d1d8a24633e6.svg";
export { ForwardRef as ReactComponent };